<template lang="pug">
  div.legend__group
    div.legend__type
      label.legend__switch.switch
        span.semibold.legend__name Теплокарты
        input.visually-hidden.switch__input(type="checkbox" v-model="showMappingLayer"  @change="onChange")
        span.switch__block
    div(
      v-show="showMappingLayer"
      v-for="option in options"
    ).legend__small-group
      label.legend__label
        input.visually-hidden.legend__radio-input(
          type="radio"
          v-model="selected"
          @change="onChange"
          :value="option.id"
        )
        span.legend__radio
        span {{option.name}}
      .legend__children(v-if='option.children && infrastructureChecked')
        label.legend__label.legend__child(v-for='child in option.children')
          input.visually-hidden.legend__radio-input(
            type="radio"
            v-model='infrastructureAction'
            @change="onChange"
            :value="child.value"
          )
          span.legend__radio
          span {{child.label}}
</template>

<script>
import { REGION_CONFIG } from '@/config/regions'
import routeMixin from '@/mixins/route-mixin'

export default {
  name: 'map-heat',
  mixins: [routeMixin],
  data: () => ({
    selected: '',
    showMappingLayer: '',
    infrastructureChecked: false,
    infrastructureAction: 'utilization',
  }),
  computed: {
    options() {
      let items = []
      for (let key in REGION_CONFIG.filterMenu) {
        items.push({
          id: key,
          name: REGION_CONFIG.filterMenu[key].title,
          children: REGION_CONFIG.filterMenu[key].children,
        })
      }
      return items
    },
  },
  watch: {
    showMappingLayer: 'onShowMappingLayer',
    $route: 'routeHandler',
  },
  methods: {
    routeHandler(newValue, oldValue) {
      const oldYear = oldValue?.query?.year
      const newYear = newValue?.query?.year
      if (oldYear !== newYear) {
        this.$emit('change', this.selected)
      }
    },
    onShowMappingLayer(newVal) {
      this.$store.commit('mappingLayer', newVal)
      if (!newVal) {
        this.selected = ''
      }
      this.onChange(this.selected)
    },
    onChange() {
      this.infrastructureChecked = this.selected === 'infrastructure'
      this.replaceRoute({ infrastructureAction: this.infrastructureAction })
      this.$emit('change', this.selected)
    },
  },
}
</script>
